var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('br'),_c('img',{attrs:{"src":require("../assets/404.png")}}),_c('br'),_c('h1',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }